import type { MetatagName } from './schema/MetatagName';

export type MetatagValues = {
    [key in MetatagName]?: string | undefined;
};

let savedMetatags: MetatagValues | undefined;
export default function findMetatag(tagName: MetatagName): string | undefined {
    if (!savedMetatags) {
        savedMetatags = getMetatags();
    }

    return savedMetatags[tagName];
}

export function getMetatags(): MetatagValues {
    if (!savedMetatags) {
        savedMetatags = calculateMetatags();
    }
    return savedMetatags;
}

function calculateMetatags(): MetatagValues {
    const result: MetatagValues = {};
    if ('document' in self) {
        const tags = Array.from(self.document.getElementsByTagName('meta'));
        for (const tag of tags) {
            result[tag.name as MetatagName] = tag.content;
        }
    }
    return result;
}

export function overrideGetMetatags(newMetatags: MetatagValues): void {
    savedMetatags = newMetatags;
}
